import React from 'react';
import { useSelector } from 'react-redux';
import { SellerBoxSizes } from '../constants';
import { translate } from '../Services/translation';
import useEcommerceDisabled from '../Hooks/useEcommerceDisabled';

const SellerBox = ({ size, seller }) => {
  const { faqPageUrl } = useSelector((state) => state.site);
  const ecommerceDisabled = useEcommerceDisabled();
  switch (size) {
    case SellerBoxSizes.small:
      return (
        <div className="seller-box seller-box--small">
          <div className="seller-box__left">
            <div className="seller-box__title">
              {translate('sellerbox.title.small')}
            </div>
            <div className="seller-box__description">
              {!ecommerceDisabled ? (
                <>
                  {seller.contactUsUrl && (
                    <a href={seller.contactUsUrl} className="seller-box__anchor">
                      {translate('sellerbox.anchor.small')}
                    </a>
                  )}{' '}
                  {translate('sellerbox.description.small')}
                </>
              ) : (
                faqPageUrl && (
                  <>
                    {translate('sellerbox.faq.description.small')}
                    {' '}
                    <a href={faqPageUrl} className="seller-box__anchor">
                      {translate('sellerbox.faq.anchor.small')}
                    </a>
                  </>
                )
              )}
            </div>
          </div>
          {seller.imageUrl && (
            <img className="seller-box__image" src={seller.imageUrl} />
          )}
        </div>
      );

    case SellerBoxSizes.large:
      return (
        <div className="seller-box seller-box--large">
          <div className="seller-box__top">
            <div className="seller-box__section">
              <div className="seller-box__title">
                {translate('sellerbox.title.large')}
              </div>
              <div className="seller-box__description">
                {translate('sellerbox.description.large')}
              </div>
            </div>
            <div className="seller-box__section">
              {seller.phone && (
                <a href={`tel:${seller.phone}`} className="seller-box__anchor">
                  {seller.phone}
                </a>
              )}
              {seller.email && (
                <a
                  href={`mailto:${seller.email}`}
                  className="seller-box__anchor"
                >
                  {seller.email}
                </a>
              )}
            </div>
          </div>
          <div className="seller-box__bottom">
            <div className="seller-box__italic-text">
              {translate('sellerbox.regards.large')}
            </div>
            {seller.name && (
              <div className="seller-box__seller-name">{seller.name}</div>
            )}
          </div>
          {seller.imageUrl && (
            <img className="seller-box__image" src={seller.imageUrl} />
          )}
        </div>
      );
    default:
      return null;
  }
};

export default SellerBox;
